

export const contactDetails = {
    email: "radinoverseas@gmail.com",
    phoneNo: "7904710512, 9884343666",
}